import React from "react";
import { LinkContainer } from "react-router-bootstrap";
import { Navbar, Nav, NavItem, NavDropdown, MenuItem } from "react-bootstrap";

const Header = () => {
  return (
    <Navbar>
      <Nav>
        <LinkContainer to="/">
          <NavItem eventKey={1}>Home</NavItem>
        </LinkContainer>
        <NavDropdown eventKey={2} title="Excercises" id="basic-nav-dropdown">
          <LinkContainer to="/exercise/Simple">
            <MenuItem eventKey={2.1}>Simple</MenuItem>
          </LinkContainer>
          <LinkContainer to="/exercise/Meme">
            <MenuItem eventKey={2.2}>Meme Generator</MenuItem>
          </LinkContainer>
        </NavDropdown>
      </Nav>
    </Navbar>
  );
};

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js